import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import NotificationsSettings from "../NotificationsSettings/NotificationsSettings";
import ProfileSettings from "../ProfileSettings/ProfileSettings";
import SecuritySettings from "../SecuritySettings";
import { urls } from "../../utils/urls";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useProfile } from "../../context/ProfileContext";
import { Badge } from "@mui/material";
import Cookies from "js-cookie";

export const accountModalTabs = {
  PROFILE: "Profile",
  SECURITY: "Security",
  NOTIFICATIONS: "Notifications",
  LOGOUT: "Logout",
};

const AccountModal = ({ isOpen, onClose, firstPage }) => {
  const { profile } = useProfile();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [activeTab, setActiveTab] = useState(
    Object.values(accountModalTabs).includes(firstPage)
      ? firstPage
      : accountModalTabs.PROFILE
  );

  function AccountModalNavButton({ tab }) {
    return (
      <Button
        variant="text"
        sx={{
          justifyContent: "flex-start",
          py: 1,
          borderBottom: activeTab === tab ? "2px solid red" : "none",
          borderRadius: 0,
        }}
        onClick={() => setActiveTab(tab)}
      >
        {tab}
      </Button>
    );
  }
  const handleLogout = () => {
    Cookies.remove("refresh_token");
    Cookies.remove("access_token");
    window.location.assign(urls.users.logout());
  };

  useEffect(() => {
    if (!isOpen) {
      setActiveTab(accountModalTabs.PROFILE);
      return;
    }
    setActiveTab(
      Object.values(accountModalTabs).includes(firstPage)
        ? firstPage
        : accountModalTabs.PROFILE
    );
  }, [firstPage, isOpen]);

  // Timezone state & browser detection
  const browserTimeZone = useMemo(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    []
  );

  const badgeCount =
    3 -
    (Boolean(profile?.email_verified) +
      Boolean(!profile.phone_number || profile?.phone_number_verified) +
      Boolean(profile?.timezone == browserTimeZone));
  return (
    <>
      <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle component="div">
          {!isDesktop && (
            <>
              <Tabs
                value={activeTab}
                onChange={(_, newVal) => setActiveTab(newVal)}
                indicatorColor="secondary"
                variant="scrollable"
                scrollButtons="auto"
                sx={{ width: "100%" }}
              >
                <Tab
                  label={accountModalTabs.PROFILE}
                  value={accountModalTabs.PROFILE}
                />
                <Tab
                  label={accountModalTabs.SECURITY}
                  value={accountModalTabs.SECURITY}
                />
                <Tab
                  label={accountModalTabs.NOTIFICATIONS}
                  value={accountModalTabs.NOTIFICATIONS}
                />
                <Tab
                  label={accountModalTabs.LOGOUT}
                  value={accountModalTabs.LOGOUT}
                />
              </Tabs>
              <Divider />
            </>
          )}
        </DialogTitle>

        <DialogContent sx={{ display: "flex", minHeight: 300 }}>
          {isDesktop && (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  width: "200px",
                  mr: 2,
                  pt: 2,
                }}
              >
                <Badge
                  badgeContent={badgeCount}
                  color="error"
                  anchorOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  <AccountModalNavButton tab={accountModalTabs.PROFILE} />
                </Badge>
                <AccountModalNavButton tab={accountModalTabs.SECURITY} />
                <AccountModalNavButton tab={accountModalTabs.NOTIFICATIONS} />
                <AccountModalNavButton tab={accountModalTabs.LOGOUT} />
              </Box>

              <Divider orientation="vertical" flexItem />
            </>
          )}

          <Box sx={{ flex: 1, pl: 2 }}>
            {activeTab === accountModalTabs.PROFILE && <ProfileSettings />}

            {activeTab === accountModalTabs.SECURITY && <SecuritySettings />}

            {activeTab === accountModalTabs.NOTIFICATIONS && (
              <NotificationsSettings />
            )}
            {activeTab === accountModalTabs.LOGOUT && (
              <Box>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleLogout}
                  disableElevation
                >
                  Logout
                </Button>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} variant="standard" color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AccountModal;
